<template>
  <q-modal v-model="modalKit" no-backdrop-dismiss no-esc-dismiss>
    <div>
      <v-header :title="$T('lending kit') + ' ' + (form.id || '') + ' - ' + (form['stock_status.description'] ? form['stock_status.description'] : '')" icon="find in page">
        <template slot="right">
          <v-button flat rounded dense color="primary"
                    icon="fa icon-close"
                    :disable="form.busy || isLoading"
                    @click="close"/>
        </template>
      </v-header>
      <card width="100%">
        <form v-if="user && form"
              class="row gutter-xs"
              @keydown="form.onKeydown($event)">
          <v-display v-model="form['lending_point.description']"
                     :label="$t('lending point')"
                     :form="form"
                     class="col-md-6 col-xs-12">
          </v-display>

          <v-display v-model="form['product_model.description']"
                     :label="$t('product model')"
                     :form="form"
                     class="col-md-6 col-xs-12">
          </v-display>

          <v-display v-model="form['product_color.description']"
                     :label="$t('product color')"
                     :form="form"
                     class="col-md-6 col-xs-12">
          </v-display>

          <v-display v-model="form.codentify"
                     :label="$t('codentify')"
                     :form="form"
                     class="col-md-3 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.child_codentify_1"
                     :label="$t('child codentify 1')"
                     :form="form"
                     class="col-md-3 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.child_codentify_2"
                     :label="$t('child codentify 2')"
                     :form="form"
                     class="col-md-3 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.uses"
                     :label="$t('lendings')"
                     :form="form"
                     class="col-md-3 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.enable_to_creation"
                     :label="$t('enable lending creation')"
                     :form="form"
                     class="col-md-6 col-sm-6 col-xs-12">
          </v-display>

          <v-radio-buttons v-if="actions.length > 1"
                           path="action"
                           v-model="action"
                           :label="$t('actions')"
                           :options="actions"
                           :form="form"
                           @input="makeActionDataAdjustments"
                           class="col-12">
          </v-radio-buttons>

          <!-- Submit Button -->
          <div class="col-12 row justify-center q-mt-md group">

            <v-button v-if="![stockStatuses['BROKEN']].includes(form['stock_status.description']) &&
                                        ((![stockStatuses['IN_LENDING'], stockStatuses['RESERVED'], stockStatuses['RETIRED'], stockStatuses['NOT_RETURNED'], stockStatuses['SOLD']].includes(form['stock_status.description']) &&
                                    'Courier' == user.role.name) ||
                                    (![stockStatuses['IN_LENDING'], stockStatuses['NOT_RECEIVED'], stockStatuses['SOLD']].includes(form['stock_status.description']) &&
                                    ('Lending Point' == user.role.name || 'Sales Expert' == user.role.name || 'MUPI' == user.role.name || 'Remote Coach' == user.role.name)))"
                      outline
                      :label="$T('move lending kit')"
                      icon="save"
                      color="highlight"
                      class="no-shadow uppercase q-btn-iqos"
                      @click.native="moveTo(actions.find(a => a.value == action).stockStatus)"
                      :loading="form.busy">
              <template slot="loading">
                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                {{ $T('saving...') | capitalize }}
              </template>
            </v-button>

          </div>

        </form>

        <div class="justify-center row layout-padding" v-else>
          <spinner-iqos size="60px"/>
        </div>

      </card>
    </div>
  </q-modal>
</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import lendingKitModel from './lendingKitModel'
import {
  QSpinnerPuff,
  QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import axios from "axios";

export default {
  mixins: [lendingKitModel],

  components: {
    QSpinnerPuff,
    QModal
  },

  props: {
    show: Boolean,
    item: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      stockStatuses: window.config.stockStatuses,
      modalKit: this.show,
      form: {},
      isLoading: false,
      action: 0,
      control: null
    }
  },

  watch: {
    show(newVal) {
      this.modalKit = newVal
    },

    item(newVal) {
      this.form = new Form(Object.assign(this.lendingKitModel, newVal))
      let stockStatuses = this.stockStatuses
      this.action = this.form['stock_status.description'] === stockStatuses['BROKEN'] ? 22 : 0
    }
  },

  methods: {
    close() {
      this.modalKit = false
      this.action = 0
      this.$emit('close')
    },

    async getNotificationData() {
      const {data} = await axios.get(`${config.appUrl}/api/v1/notifications`)
      this.$store.commit('notifications/setToExpire', data.data.ordersToExpire)
      this.$store.commit('notifications/setExpiredNotClosed', data.data.ordersExpiredNotClosed)
      this.$store.commit('notifications/setKitsPendingReception', data.data.kitsPendingReception)
    },

    moveTo(stockStatus) {
      this.form.post(`${this.baseUrl}/lending-kit/${this.form.id}/move-to/${stockStatus}`, {
        status
      })
          .then(({data}) => {
            if (data.hasOwnProperty('status') && !data.status)
            {
              this.$q.dialog({
                title: this.$T("error"),
                message: data.message,
                preventClose: true,
                  ok: {
                      label: this.$T('ok'),
                      outline: true,
                      rounded: true,
                      color: 'primary',
                      noCaps: true
                  },
              })
            } else {
              this.close()
              this.$emit('updated')
              this.$q.dialog({
                title: this.$T('success'),
                message: data.success.message,
                preventClose: true,
                stackButtons: false,
                  ok: {
                      label: this.$T('ok'),
                      outline: true,
                      rounded: true,
                      color: 'primary',
                      noCaps: true
                  },
              })
            }
          })
          .catch(err => {
            let responseMessage
            if (err.response.data && err.response.data.error) {
              responseMessage = err.response.data.error.message
            } else {
              responseMessage = this.$T("this action cannot be run")
            }
            this.$q.dialog({
              title: this.$T("error"),
              message: responseMessage,
              preventClose: true,
              ok: {
                label: this.$T('ok'),
                outline: true,
                rounded: true,
                color: 'primary',
                noCaps: true
              },
            })
          })
      this.getNotificationData()
    },

    makeActionDataAdjustments() {

    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    baseUrl() {
      return `${window.config.appUrl}/api/v1/${changeCase.paramCase(this.user.role.name)}`
    },

    actions() {
      let role = this.user.role.name
      let stockStatus = this.form['stock_status.description']
      let stockStatuses = this.stockStatuses
      let forbiddenStatuses = [
        stockStatuses['IN_LENDING'],
        stockStatuses['RESERVED'],
        stockStatuses['RETIRED'],
        stockStatuses['NOT_RETURNED']
      ]

      let actions = [{value: 0, label: this.$T('no action')}]

      if ((role == 'Lending Point') && (stockStatus === stockStatuses['PENDING_RECEPTION'])) {
        actions = [
          {value: 0, stockStatus: 'confirm-reception', label: `> ${this.$T('confirm reception')}`},
          {value: 9, stockStatus: 'not-received', label: `> ${this.$T('not received')}`, color: 'red'}
        ]
      } else if (stockStatus === stockStatuses['CLEAR']) {
        actions = [
          {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
          {value: 22, stockStatus: 'broken', label: `> ${this.$T('broken')}`}
        ]
      } else {
        if ((role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || role == 'Remote Coach') && stockStatus === stockStatuses['AVAILABLE']) {
          actions = [
            {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
            {value: 22, stockStatus: 'broken', label: `> ${this.$T('broken')}`}
          ]
        } else {
          if ((!forbiddenStatuses.includes(stockStatus) && role == 'Courier') ||
              (![stockStatuses['IN_LENDING'], stockStatuses['NOT_RECEIVED'], stockStatuses['BROKEN'], stockStatuses['SOLD']].includes(stockStatus) && (role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || role == 'Remote Coach'))) {
            actions = [
              {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
              {value: 9, stockStatus: 'not-received', label: `> ${this.$T('not received')}`, color: 'red'}
            ]
          }
        }
      }

      return actions
    },

    loadForm() {
      return this.form && this.form.stock_status && this.form.stock_status.description
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/_lendingKitDetail.vue